import { render, staticRenderFns } from "./AfterSalesOrdersMobile.vue?vue&type=template&id=8dd0dc08&scoped=true&"
import script from "./AfterSalesOrdersMobile.vue?vue&type=script&lang=js&"
export * from "./AfterSalesOrdersMobile.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesOrdersMobile.vue?vue&type=style&index=0&id=8dd0dc08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd0dc08",
  null
  
)

export default component.exports